import React , { useState , useEffect , useRef } from 'react'

import { ApiCallGet , ApiCallPost } from '../ApiCall/ApiCall';


import Select from 'react-select';


import { useNavigate ,  useLocation } from "react-router-dom";






export default function Clientes() {
  const [file, setFile] = useState(null);
  const [theOptions,setTheOptions] = useState([])
  const [campain,setCampain] = useState( null )

  const selectRef = useRef()


  const navigate = useNavigate()
  const location = useLocation()


  var options = [
 
  ]

  function onSubmit(e)
  {
    e.preventDefault()

  
    const formData = new FormData();
    formData.append('file', file);

    console.log( "FormData = " , formData )

    ApiCallPost('clientes', formData)
      .then(response => {
        console.log(response.data);
      })
      .catch(error => {
        console.error(error);
      });
  }


  function handleFileChange( e )
  {

      console.log( "fileName keys = " ,  e.target.files[0].name )

      if (e.target.files) {
          console.log("file asignado ")
          setFile(e.target.files[0]);
      }
  }


  function onSelectCampain( val )
  {
    console.log( "val = " + val.value )
    console.log( "label = " + val.label )

    setCampain( val ) // Datos de la campaña seleccionada
  }



  useEffect( () => {

    if ( location.state === null ){
      navigate("/")
      return ; 
    }

    ApiCallGet('getcampains')
    .then( (response) => {
      //console.log( "Nos esta llegando la respuesta")
      //console.log( response )
      for( var i = 0 ; i < response.length ; i++ ){
        options.push({ value : response[i].id, label : response[i].name })
      }
      setTheOptions( options )
    } )
    .catch( (error) => {
      console.log( error )
    })


  } , [] )



  function handleUpload(event) {
    event.preventDefault();


    //const theFile = document.getElementById( "uploadcodigo").files[0] ;

    const reader = new FileReader() ; 



    reader.readAsText(file ) ;



    reader.onload = async (e) => {
      const data2 = e.target.result ;


      //console.log( "Handle upload " + data2) ;

      var data3 = data2.split("\n")

      console.log( "data3 = " + data3 )


      var arrUp = [] // Este es el arreglo que se sube a la nube


      for( var i = 1 ; i < data3.length ; i++ )
      {
        console.log( "data3 = " + data3[i] )

        var theSplit = data3[i].split(",")

        if ( theSplit.length === 1 ){
          continue
        } 

        var cleanName = theSplit[1].replace( "\r" , "" ) ;

        var myData = {

          telefono : theSplit[0] ,
          name : cleanName  
        }

        arrUp.push( myData )

      }


      // var classUp = {

      //   campain : campain.value ,
        
      //   data : arrUp
      // }

  

      var fullData = {
          data : arrUp ,
          campain : campain.value
      }

      ApiCallPost( "clientes" ,  fullData )
      .then((result) => {
        console.log("Result = " + result)
      })
      .catch((err) => {
        console.log(err)
      })
  }


  return ;


    const formData = new FormData();

    if ( file === null ){
      alert( "No hay archivo seleccionado" )
      return
    }


    console.log( "fileName = " + file.name )

    formData.append('file', file);
    formData.append('programa', "prueba");
    console.log("FormData = ", formData)
    ApiCallPost('clientes', formData)
      .then(response => {
        console.log(response.data);
      })
      .catch(error => {
        console.error(error);
      });
  }

  return (
    <div className='d-flex flex-column  justify-content-center box-1 backemployer-2 centersearch' >

      <div className='d-flex flex-column justify-content-center box-1 backemployer-2 mb-5 form-2 w-75'  id="page1" style={{margin : 'auto'}}>


      <div className='row'>
                <div className='col-sm-4'>

                    

                </div>
                <div className='col-sm-4'>
                    <h5>Carga de datos de Clientes</h5>
                </div>
        </div> 

        <form id='form' onSubmit={onSubmit}>

            <div className='row'>

              <div className='col-4'>
                <label className="form-label m-0" htmlFor="file">File</label>
                <input type="file" className="form-control" onChange={handleFileChange} id="file" />
              </div>

              <div className='col-5 mt-3' >
                <label className="form-label m-0" htmlFor="campain">Campaña</label>
                <Select ref={selectRef}  options={theOptions} id="campain"
                  placeholder="Seleccione una campaña" onChange={onSelectCampain}/>  

              </div> 
              

            </div>

            {/* <div className="input-group">
                <input id="file" type="file" onChange={handleFileChange} />
            </div> */}

            {file && (
                <section>
                  File details:
                  <ul>
                    <li>Name: {file.name}</li>
                    <li>Type: {file.type}</li>
                    <li>Size: {file.size} bytes</li>
                    
                  </ul>
                </section>
              )}

              {file && (
                <button 
                  onClick={handleUpload}
                  className="submit"
                >Upload a file</button>
              )}

              {/*<div className='row'>
                <div className='col-4'>
                  <button type="submit"  className="btn btn-primary mt-3 button-3"  >Aceptar</button> 
                </div>
              </div>*/}

          </form>
      </div>
    </div>
  )
}
